const headerData = [{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 150,
	},
	{
		prop: "LEVEL3",
		label: "LEVEL3",
		columnwidth: 150,
	},
	{
		prop: "CusName",
		label: "经销商名称",
	},
	{
		prop: "RebateRatio",
		label: "返利点",
		columnwidth: 150,
	},
	{
		prop: "StartDate",
		label: "启效日期",
		columnwidth: 130, 
	},
	{
		prop: "EndDate",
		label: "有效期至",
		columnwidth: 130,
	},
	{
		prop: "Creator",
		label: "创建人",
		columnwidth: 155,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 180,
	}
];
export default headerData;